import { render, staticRenderFns } from "./ObjectAdd.vue?vue&type=template&id=3f6b64c8&scoped=true"
import script from "./ObjectAdd.vue?vue&type=script&lang=js"
export * from "./ObjectAdd.vue?vue&type=script&lang=js"
import style0 from "./ObjectAdd.vue?vue&type=style&index=0&id=3f6b64c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6b64c8",
  null
  
)

export default component.exports